import React from 'react';
import { motion } from 'framer-motion';
import ServiceCard from './servicecard';

const DesktopServicesGrid = ({ services, onServiceClick }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 80, scale: 0.9 },
    visible: (i) => ({ 
      opacity: 1, 
      y: 0,
      scale: 1,
      transition: { 
        duration: 0.7, 
        ease: "easeOut",
        delay: i * 0.15
      }
    })
  };

  return (
    <div className="desktop-cards">
      <div className="row">
        {services.map((service, index) => (
          <motion.div 
            key={service.id}
            className="col-lg-4 col-md-6"
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            custom={index}
          >
            <ServiceCard 
              service={service} 
              onServiceClick={onServiceClick}
              isMobile={false}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default DesktopServicesGrid;